<template>
  <button
    type="button"
    :class="buttonClassList"
    :disabled="loading"
    @click="handleClick"
  >
    <ButtonLoading :loading="loading">
      <slot></slot>
    </ButtonLoading>
  </button>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import ButtonLoading from "../ui/ButtonLoading.vue";

/**
 * TODO: Treat test pots as an actual size in the CMS so that the only thing we need to pass to this component
 * is a variant object
 */

export default {
  name: "TestPotAddToCart",

  components: { ButtonLoading },

  props: {
    link: {
      type: Boolean,
      default: false,
    },
    colourTitle: {
      type: String,
      required: true,
    },
    coatingColour: {
      type: String,
      default: "",
    },
    paintColour: {
      type: String,
      default: "",
    },
    textColour: {
      type: String,
      default: "",
    },
    productTitle: {
      type: String,
      default: "",
    },
    sheen: {
      type: String,
      default: "",
    },
    sku: {
      type: String,
      default: "",
    },
    source: {
      type: String,
      required: true,
    },
    testPot: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    buttonStyle: {
      type: String,
      default: "default",
    },
  },

  computed: {
    buttonClassList() {
      let classList;
      if (this.link) {
        if (this.textColour) {
          classList = `link underline text-${this.textColour} border-${this.textColour}`;
        } else {
          classList = `link underline`;
        }
      }
      if (!this.link) {
        const buttonStyle =
          this.buttonStyle === "default" ? "btn-soft" : "btn-pill";

        if (this.textColour === "white") {
          classList = `${buttonStyle} ${buttonStyle}--alt`;
        } else {
          classList = `${buttonStyle}`;
        }
      }
      return classList;
    },
  },

  methods: {
    ...mapMutations(["openSiteCart"]),
    ...mapActions("cart", ["addItem"]),

    handleClick() {
      this.addItem({
        purchasable: this.testPot,
        quantity: 1,
        options: null,
      });
      this.openSiteCart();
    },
  },
};
</script>
